export const initialState = {
  isFetching: false,
  data: {
    press: [],
    bloggers: [],
    reviews: [],
  },
}

export const set = (state, payload) => (
  { ...state, data: payload, isFetching: false }
)

export const setFetchingStatus = (state, payload) => (
  { ...state, isFetching: payload }
)

export const reset = () => initialState
